import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAuthentication from '../authentication/authentication.reducer';

export const selectAuthenticationState = createFeatureSelector<fromAuthentication.State>(fromAuthentication.authenticationFeatureKey);

export const selectAuthenticated = createSelector(selectAuthenticationState, (state) => state.isAuthenticated);
export const selectUser = createSelector(selectAuthenticationState, (state) => state.user);
export const selectSignInError = createSelector(selectAuthenticationState, (state) => state.signInError);
